import Sidebar from './Sidebar';
import TopNav from './TopNav';
import Breadcrumbs from './Breadcrumbs';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';
import { moduleRegistry } from '../modules/registry';

/** Composes the sidebar, top nav, breadcrumbs, and the routed page content. */
export default function AppShell({ activeModule, pathname, children }) {
  const { enabledModules, permissions } = useAuth();
  const { t } = useI18n();

  return (
    <div className="app-shell">
      <a href="#main-content" className="skip-link">
        {t('common', 'skipToContent')}
      </a>
      <Sidebar
        modules={moduleRegistry}
        activeModuleKey={activeModule?.key}
        enabledModules={enabledModules}
        permissions={permissions}
      />
      <div className="app-shell__body">
        <TopNav />
        <Breadcrumbs activeModule={activeModule} pathname={pathname} />
        <main id="main-content" className="app-shell__main" tabIndex={-1}>{children}</main>
      </div>
    </div>
  );
}
